import type {UpdateAccountRelationResult} from 'src/openapi/admin/models/UpdateAccountRelationResult';
import type {UpdateUserRelationResult} from 'src/openapi/admin/models/UpdateUserRelationResult';

export const entitlementsResultSortComparator = (
    a: UpdateUserRelationResult | UpdateAccountRelationResult,
    b: UpdateUserRelationResult | UpdateAccountRelationResult,
) => {
    if (a.roleName && b.roleName) {
        return a.roleName.localeCompare(b.roleName);
    } else if (a.roleName) {
        return -1;
    } else if (b.roleName) {
        return 1;
    } else if (a.grantName && b.grantName) {
        return a.grantName.localeCompare(b.grantName);
    } else if (a.grantName) {
        return -1;
    } else if (b.grantName) {
        return 1;
    } else {
        return 0;
    }
};
